import service from '@/middleware'

const ecologicalUnitApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     * @param {*} enterpriseIds
     */
    async findAll(pageSize, pageNumber, headers, enterpriseIds) {
        const url = `/api/ecological-unit/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
        const response = await service.http.post(url, enterpriseIds)
        return response
    },
    /**
     * Total de grupos para el paginador de la tabla del ABM
     * @param {*} enterpriseIds
     */
    async getTotal (enterpriseIds) {
        const result = await service.http.post(`/api/ecological-unit/total`, enterpriseIds)
        return result
    },
    /**
     * Para validar el nombre de un grupo
     * @param {*} name
     * @param {*} enterpriseId
     * @param {*} farmId
     */
    async validateEcologicalUnitName (name, enterpriseId, farmId) {
        const result = await service.http.get(`/api/ecological-unit/validate-name/${name}/${enterpriseId}/${farmId}`)
        return result
    },
    /**
     * Para crear un nuevo grupo
     * @param {*} ecologicalUnitDto
     * @param {*} thingIds
     */
    async create (ecologicalUnitDto) {
        const result = await service.http.post(`/api/ecological-unit/create`, { ecologicalUnitDto })
        return result
    },
    /**
     * Para actualizar un grupo
     * @param {*} ecologicalUnitDto
     * @param {*} thingIds
     */
    async update (ecologicalUnitDto) {
        const result = await service.http.put(`/api/ecological-unit/update`, { ecologicalUnitDto })
        return result
    },
    /**
     * Para eliminar un grupo
     * @param {*} enterpriseId
     * @param {*} farmId
     * @param {*} idEcologicalUnit
     */
    async deleteOne (enterpriseId, farmId, idEcologicalUnit) {
        await service.http.delete(`/api/ecological-unit/${enterpriseId}/${farmId}/${idEcologicalUnit}`)
    },
    /**
     * Eliminación múltiple
     * @param {*} deletes
     */
    async deleteMany (deletes) {
        await service.http.put(`/api/ecological-unit/multiple-delete`, deletes)
    },
    /**
     * Obtener las unidades ecologicas para una empresa y finca
     * @param {*} enterpriseId 
     * @param {*} farmId 
     */
    async findForSelector (enterpriseId, farmId) {
        const result = await service.http.get(`/api/ecological-unit/for-selector`, { params: { enterpriseId, farmId } })
        return result
    },

    /**
     * Verificar si una unidad ecologica puede ser eliminada
     * Devuelve true si no está asociada a ninguna unidad de manejo
     * @param {*} enterpriseId
     * @param {*} farmId
     * @param {*} ecologicalUnitId
     */
    async canDeleteEcologicalUnit (enterpriseId, farmId, ecologicalUnitId) {
        const result = await service.http.get(`/api/ecological-unit/can-delete/${enterpriseId}/${farmId}/${ecologicalUnitId}`)
        return result
    },

    /**
     * Verificar si un arreglo de unidades ecologicas pueden ser eliminadas
     * Devuelve true si ninguna está asociada a una unidad de manejo
     * @param {*} idsToDelete
     */
    async canDeleteEcologicalUnits (idsToDelete) {
        const result = await service.http.post('/api/ecological-unit/can-delete', { idsToDelete })
        return result
    }

}

export default ecologicalUnitApi
